var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAris(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.05 105.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.7;}.cls-1,.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.4,72.63h-15.61l-3.01,10.5h-12.6l17.01-50.05h12.88l17.01,50.05h-12.6l-3.08-10.5ZM141.56,44.49s-1.12,5.46-2.03,8.61l-2.87,9.73h9.87l-2.8-9.73c-.91-3.15-2.03-8.61-2.03-8.61h-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.27,47.08h11.62v6.09c0,1.19-.14,2.24-.14,2.24h.14c1.54-4.9,6.09-8.96,11.48-8.96.7,0,1.4.14,1.4.14v11.9s-.98-.21-2.45-.21c-2.87,0-7.56.91-9.31,6.3-.42,1.33-.63,2.94-.63,4.9v13.65h-12.11v-36.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.37,47.08h12.11v36.05h-12.11v-36.05ZM199.5,33.08h11.83v9.45h-11.83v-9.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.81,70.53s3.99,3.64,9.17,3.64c1.82,0,3.57-.49,3.57-1.68,0-3.15-16.87-3.5-16.87-15.26,0-6.79,6.51-10.99,14.84-10.99s12.67,4.13,12.67,4.13l-4.13,8.61s-3.5-2.94-8.54-2.94c-1.82,0-3.57.49-3.57,1.75,0,2.73,16.87,3.15,16.87,14.77,0,6.16-5.46,11.41-14.77,11.41s-14.42-5.32-14.42-5.32l5.18-8.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.5 83.58 15.63 55.98 49.18 55.7 64.97 83.69 31.5 83.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "96.48 83.45 64.97 83.69 32.86 27.07 48.49 0 96.48 83.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "43.9 105.15 12.53 105.15 0 83.05 15.63 55.98 43.9 105.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.42,83.96c2.58,0,4.63,2.1,4.63,4.72s-2.06,4.73-4.63,4.73-4.6-2.1-4.6-4.73,2.05-4.72,4.6-4.72ZM251.42,92.53c2.08,0,3.69-1.68,3.69-3.84s-1.6-3.84-3.69-3.84-3.65,1.68-3.65,3.84,1.59,3.84,3.65,3.84ZM249.84,86.23h1.88c.92,0,1.54.58,1.54,1.49,0,.75-.49,1.19-.89,1.29v.03s.05.05.17.27l.93,1.8h-1.01l-.91-1.89h-.79v1.89h-.92v-4.88ZM251.53,88.55c.48,0,.79-.31.79-.83s-.31-.79-.79-.79h-.78v1.62h.78Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAris);
export default __webpack_public_path__ + "static/media/aris.b4c4a5e80dbdd91a8b9564efac1f78a2.svg";
export { ForwardRef as ReactComponent };